// extracted by mini-css-extract-plugin
module.exports = {"content":"employee_content__2fmv3","half_module":"employee_half_module__2bZZ9","vacation_table":"employee_vacation_table__3W6EY","pointer":"employee_pointer__jjoBC"};